import type { IFinEnvironmentRestrictedCharactersConfig } from './environment-types';

/**
 * Character rule the three QNB environments put on the onboarding fields that reach the core banking
 * system and payment instructions — the bank account fields, the customer's single-line fields, the
 * addresses and a representative's or director's name and role. Letters, digits and the space are always
 * allowed; `allowedSpecialCharacters` lists only the punctuation that joins them. A deployment without
 * `restrictedCharacters` keeps the fields unrestricted.
 *
 * Equation takes the SWIFT X punctuation that MT messages carry — `/-?:().,'+` — minus the colon
 * and the question mark, which it refuses. Curly braces and the asterisk are in no set: braces
 * delimit a SWIFT message's own blocks.
 */
export const QNB_RESTRICTED_CHARACTERS: IFinEnvironmentRestrictedCharactersConfig = {
  allowedSpecialCharacters: "/-().,'+",
};
